import { HttpClient } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';

@Component({
    selector: 'app-mm-right-column',
    templateUrl: './mm-right-column.component.html',
    styleUrls: ['./mm-right-column.component.scss'],
})
export class MmRightColumnComponent implements OnInit {

    public modelLocator: ModelLocatorService;

    protected router: Router;

    public segmentacao: any = {};
    public bannersVeiculacao: any = [];

    constructor(
        injector: Injector,
        private http: HttpClient,
        modelLocatorService: ModelLocatorService
    ) {
        this.router = injector.get(Router);
        this.modelLocator = modelLocatorService;
    }

    ngOnInit() {

        this.segmentacao = {
            slot: 'direita',
            cpf: this.modelLocator.dadosLogin.cpf,
            owner: this.modelLocator.dadosLogin.idowner,
            perfil: this.modelLocator.dadosLogin.idperfil
        };

        if (this.modelLocator.dadosLogin.lojas) {
            this.segmentacao.lojas = this.modelLocator.dadosLogin.lojas;
        }

        this.listaBanners();

    }

    listaBanners() {

        //console.log('>>>>>>>>>> Listando Banner.');

        try {

            let config = {
                headers: {
                    "x-token": this.modelLocator.configUso.X_TOKEN_API,
                    "auth-token": this.modelLocator.dadosLogin.hash_auth
                }
            };

            let url = this.modelLocator.configUso.urlApiPadrao + 'auth/hotsite/v1/banners/veiculacao';

            this.http.post(url, this.segmentacao, config)
                .subscribe(data => {

                    //console.log('>>>>> Banners: ' + JSON.stringify(data['result']));

                    if (data['status'] == 200) {
                        this.bannersVeiculacao = data['result'];
                    }

                },
                    error => {

                        if (error['status'] == 401) {

                            alert(error.error.message);
                            this.modelLocator.logado = false;
                            localStorage.clear();
                            this.modelLocator.urlretorno = '';
                            this.router.navigate(['/login']);

                        }

                    });

        } catch (err) {

            //console.log('>>>>> banner error: Erro ao listar banner.');
        }

    };

    touchGoToRoute(rota) {

        //console.log('>>>>>>>>>> Alterando página: ' + rota);

        //console.log('>>>>> index: ' + rota.lastIndexOf('http'));

        if (rota.lastIndexOf('http') >= 0) {
            //console.log('>>>>> rota externa: ' + rota);
            window.open(rota, '_blank', 'location=yes');

        } else {
            //console.log('>>>>> rota interna: ' + rota);
            this.router.navigate([rota]);
        }

    };

}